<template>
  <a
    v-if="visible"
    class="tooltip"
    :data-tooltip="showTooltip ? 'Not approved' : false"
    :href="item.chocoPackage.GalleryDetailsUrl"
    target="_blank"
  >
    <slot></slot>
  </a>
</template>

<script>
import checks from "@/utils/packageCheck";

export default {
  props: { item: Object, showTooltip: Boolean },
  computed: {
    visible() {
      return checks.isNotApproved(this.item);
    }
  }
};
</script>
